import React, { useState, useEffect/*, useCallback, useRef*/ } from 'react'

// Deps
// import { connect } from 'react-redux'

// Functions
import normalizePhone from 'functions/normalize-phone'

// Partials
import Btn from 'views/shared/partials/btn'
import Collapser from 'views/shared/partials/collapser'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'

// Hooks
import useCities from 'hooks/cities'
import useDistricts from 'hooks/districts'

// Services
import orderServices from 'services/order'
import companyServices from 'services/company'

// Fixed Data
import invoiceTypes from 'data/invoice-types'
import customOrderTypes from 'data/custom-order-types'

const ClientModal = (props) => {
	const clientID = props.clientID;
	const close = props.close;

	const [submitting, setSubmitting] = useState(false);
	const [clientData, setClientData] = useState(clientID ? null : false);
	
	const [selectedCity, setSelectedCity] = useState(null);
	const [selectedDistrict, setSelectedDistrict] = useState(null);

	const [selectedInvoiceCity, setSelectedInvoiceCity] = useState(null);
	const [selectedInvoiceDistrict, setSelectedInvoiceDistrict] = useState(null);

	const [invoiceInfoTabOpen, setInvoiceInfoTabOpen] = useState(false);

	const cities = useCities();
	const districts = useDistricts(selectedCity);
	const invoiceDistricts = useDistricts(selectedInvoiceCity);

	const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);

	useEffect(() => {
		if(clientID) {
			companyServices.getClient(clientID).then((payload) => {
				payload.phone_number = normalizePhone(payload.phone_number);
				setClientData(payload);
			}).catch(() => {
				close();
			});
		}
	}, [clientID, close])

	useEffect(() => {
		if(clientData && cities) {
			if(clientData.delivery_city) {
				setSelectedCity(cities.find(c => c.name.toString() === clientData.delivery_city.toString()));
			}
			else {
				setSelectedCity(null);
			}
			if(clientData.invoice_city) {
				setSelectedInvoiceCity(cities.find(c => c.name.toString() === clientData.invoice_city.toString()));
			}
			else {
				setSelectedInvoiceCity(null);
			}
		}
	}, [clientData, cities])

	useEffect(() => {
		if(clientData && districts) {
			if(clientData.delivery_district) {
				setSelectedDistrict(districts.find(c => c.name.toString() === clientData.delivery_district.toString()));
			}
			else {
				setSelectedDistrict(null);
			}
		}
	}, [clientData, districts])

	useEffect(() => {
		if(clientData && invoiceDistricts) {
			if(clientData.invoice_district) {
				setSelectedInvoiceDistrict(invoiceDistricts.find(c => c.name.toString() === clientData.invoice_district.toString()));
			}
			else {
				setSelectedInvoiceDistrict(null);
			}
		}
	}, [clientData, invoiceDistricts])

	const submit = (formData) => {
		setSubmitting(true);

		let submitData = { ...formData, create_or_update_client: 'create'};

		if(clientData) {
			submitData.create_or_update_client = 'update';
			submitData.client_code = clientData.client_code;
		}

		if(selectedCity) {
			submitData.client_delivery_city = selectedCity.name;
		}
		if(selectedDistrict) {
			submitData.client_delivery_district = selectedDistrict.name;
		}
		if(selectedInvoiceCity) {
			submitData.client_invoice_city = selectedInvoiceCity.name;
		}
		if(selectedInvoiceDistrict) {
			submitData.client_invoice_district = selectedInvoiceDistrict.name;
		}

		orderServices.expressOrder(submitData).then((payload) => {
			if(props.onSuccess) {
				props.onSuccess();
			}
			close();
			//openModal('order-summary', { orderCode: payload.order_business_code });
		}).catch(() => {

		}).finally(() => {
			setSubmitting(false);
		});
	}

	const validationChange = (invalidFields) => {
		let invoiceFieldInvalid = false;

		for(const key in invalidFields) {
			if(key.startsWith('client_invoice')) {
				invoiceFieldInvalid = true;
			}
		}

		if(invoiceFieldInvalid) {
			setInvoiceInfoTabOpen(true);
		}
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			onValidationChange={validationChange}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{clientData === false ? 'Müşteri Oluştur': 'Müşteriyi Düzenle'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={clientData === null} />		

				{(clientData !== null) &&
					<React.Fragment>
						<Collapser className="modal-group" title="Müşteri Bilgileri" open disableToggle>
							<div className="grid-container">
								<div className="row">
									<div className="col x8">
										<FormInput
											disabled={submitting}
											type="select"
											z="6"
											label="Müşteri Tipi"
											placeholder="Bir Müşteri Tipi Seçin"
											options={invoiceTypes}
											onChange={(type) => { setSelectedInvoiceType(type ? type.value : null); }}
											name="client_invoice_type"
											defaultValue={invoiceTypes[0]}
											value={clientData ? invoiceTypes[clientData.invoice_type - 1] : undefined} />
									</div>
									<div className="col x4">
										<FormInput
											disabled={submitting}
											type="select"
											z="5"
											label="Serbest Ödeme Özelliği"
											placeholder="Seçiniz"
											options={customOrderTypes}
											name="client_custom_order"
											defaultValue={clientData ? customOrderTypes.find((type) => ( type.value === clientData.custom_order )) : customOrderTypes[2]} />
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<FormInput
											disabled={submitting}
											type="text"
											label={selectedInvoiceType === 1 ? 'Müşteri Adı' : 'Yetkili Adı'}
											placeholder={selectedInvoiceType === 1 ? 'Müşteri Adı Girin' : 'Yetkili Adı Girin'}
											validation={{
												required: (selectedInvoiceType === 1 ? 'Müşteri adı girmelisiniz' : 'Yetkili adı girmelisiniz'),
											}}
											name="client_executive_name"
											value={clientData ? clientData.executive_name : undefined} />
									</div>
									<div className="col x6">
										<FormInput
											disabled={submitting}
											type="text"
											label={selectedInvoiceType === 1 ? 'Müşteri Soyadı' : 'Yetkili Soyadı'}
											placeholder={selectedInvoiceType === 1 ? 'Müşteri Soyadı Girin' : 'Yetkili Soyadı Girin'}
											validation={{
												required: (selectedInvoiceType === 1 ? 'Müşteri soyadı girmelisiniz' : 'Yetkili soyadı girmelisiniz'),
											}}
											name="client_executive_surname"
											value={clientData ? clientData.executive_surname : undefined} />
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<FormInput
											disabled={submitting}
											type="email"
											label="E-Posta"
											placeholder="E-Posta Adresi Girin"
											validation={{
												required: "E-posta adresi girmelisiniz",
												email: "Geçerli bir e-posta girmelisiniz",
											}}
											name="client_email"
											value={clientData ? clientData.email : undefined} />
									</div>
									<div className="col x6">
										<FormInput
											type="phone"
											disabled={submitting}
											mask="phone"
											label="Cep Telefonu"
											placeholder="Cep Telefonu Girin"
											validation={{
												required: "Cep telefonu girmelisiniz",
												phone: "Geçerli bir telefon numarası girmelisiniz",
											}}
											name="client_phone_number"
											value={clientData ? clientData.phone_number : undefined} />
									</div>
								</div>
							</div>
						</Collapser>


						<Collapser
							className="modal-group"
							title="Adres Bilgileri">
							<div className="grid-container">
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="text"
											mask="phone"
											label="Telefon Numarası"
											// validation={{
											// 	required: 'Bir telefon numarası girmelisiniz.'
											// }}
											value={clientData ? clientData.delivery_phone : undefined}
											name="client_delivery_phone" />
									</div>
								</div>
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="text"
											label="Teslimat Yapılacak Kişi"
											// validation={{
											// 	required: 'Teslimat yapılacak kişiyi girmelisiniz.'
											// }}
											value={clientData ? clientData.delivery_owner : undefined}
											name="client_delivery_owner" />
									</div>
								</div>
								<div className="row">
									<div className="col x6 m-x6">
										<FormInput
											isSearchable
											disabled={submitting}
											type="select"
											label="İl"
											options={cities}
											// validation={{
											// 	required: 'Bir şehir adı girmelisiniz.'
											// }}
											value={selectedCity}
											onChange={setSelectedCity}
											name="client_delivery_city" />
									</div>
									<div className="col x6 m-x6">
										<FormInput
											isSearchable
											disabled={submitting || !districts}
											type="select"
											label="İlçe"
											options={districts}
											// validation={{
											// 	required: 'Bir ilçe adı girmelisiniz.'
											// }}
											value={selectedDistrict}
											onChange={setSelectedDistrict}
											name="client_delivery_district" />
									</div>
								</div>
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="text"
											label="Adres İsmi"
											// validation={{
											// 	required: 'Bir adres ismi girmelisiniz.'
											// }}
											value={clientData ? clientData.delivery_title : undefined}
											name="client_delivery_title" />
									</div>
								</div>
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="textarea"
											label="Açık Adres"
											rows={3}
											// validation={{
											// 	required: 'Bir adres girmelisiniz.'
											// }}
											value={clientData ? clientData.delivery_address : undefined}
											name="client_delivery_address" />
									</div>
								</div>
							</div>
						</Collapser>

						<Collapser
							className="modal-group"
							title="Fatura Bilgileri"
							open={invoiceInfoTabOpen}>
							<div className="grid-container">
								<div className="row">
									<div className="col x6">
										<FormInput
											readOnly={clientData || submitting}
											type="text"
											value={clientData ? clientData.client_code : undefined}
											label="Cari Kodu"
											// validation={{
											// 	required: 'Bir cari kodu girmelisiniz.'
											// }}
											name="client_code" />
									</div>
									<div className="col x6">
										<FormInput
											disabled={submitting}
											type="text"
											value={clientData ? clientData.company_name : undefined}
											label="Fatura Ünvanı"
											// validation={{
											// 	required: 'Bir şirket adı girmelisiniz.'
											// }}
											name="client_company_name" />
									</div>
								</div>
								{selectedInvoiceType === 2 ?
									<div className="row">
										<div className="col x6">
											<FormInput
												key="client_tax_office"
												disabled={submitting}
												type="text"
												value={clientData ? clientData.tax_office : undefined}
												label="Vergi Dairesi"
												// validation={{
												// 	required: 'Bir vergi dairesi girmelisiniz.'
												// }}
												name="client_tax_office" />
										</div>
										<div className="col x6">
											<FormInput
												key="client_tax_number"
												disabled={submitting}
												type="text"
												value={clientData ? clientData.tax_number : undefined}
												label="Vergi No"
												// validation={{
												// 	required: 'Bir vergi numarası girmelisiniz.'
												// }}
												name="client_tax_number" />
										</div>
									</div>
									:
									<div className="row">
										<div className="col x10">
											<FormInput
												key="client_identity_number"
												disabled={submitting}
												type="number"
												value={clientData ? clientData.identity_number : undefined}
												maxLength="11"
												label="TC Kimlik No"
												// validation={{
												// 	required: 'Bir kimlik numarası girmelisiniz.',
												// }}
												name="client_identity_number" />
										</div>
									</div>
								}
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="text"
											value={clientData ? clientData.invoice_name : undefined}
											label="Fatura İsmi"
											// validation={{
											// 	required: 'Bir fatura ismi girmelisiniz.'
											// }}
											name="client_invoice_name" />
									</div>
								</div>
								<div className="row">
									<div className="col x10">
										<FormInput
											disabled={submitting}
											type="textarea"
											value={clientData ? clientData.invoice_address : undefined}
											label="Fatura Adresi"
											rows={3}
											// validation={{
											// 	required: 'Bir fatura adresi girmelisiniz.'
											// }}
											name="client_invoice_address" />
									</div>
								</div>
								<div className="row">
									<div className="col x6">
										<FormInput
											isSearchable
											disabled={submitting}
											type="select"
											label="İl"
											options={cities}
											// validation={{
											// 	required: 'Bir şehir seçmelisiniz.'
											// }}
											value={selectedInvoiceCity}
											onChange={setSelectedInvoiceCity}
											name="client_invoice_city" />
									</div>
									<div className="col x6">
										<FormInput
											isSearchable
											disabled={submitting || !invoiceDistricts}
											type="select"
											label="İlçe"
											options={invoiceDistricts}
											// validation={{
											// 	required: 'Bir ilçe seçmelisiniz.'
											// }}
											value={selectedInvoiceDistrict}
											onChange={setSelectedInvoiceDistrict}
											name="client_invoice_district" />
									</div>
								</div>
							</div>
						</Collapser>
					</React.Fragment>
				}		
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting}
					type="submit">
					{clientID ? 'Güncelle' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

ClientModal.defaultProps = {
	className: '',
	containerClass: 'modal-client mobile-full',
	name: 'client',
	title: false,
	content: false,
	source: false,
}

export default ClientModal